import { getApiClient } from './client'

const prefix = '/mail-v2'

// -- Helpers ---

function unwrap(res) {
  return res.data?.data ?? res.data ?? {}
}

function unwrapList(res) {
  const payload = res.data?.data ?? res.data
  if (payload && typeof payload === 'object' && !Array.isArray(payload) && Array.isArray(payload.data)) {
    return payload
  }
  if (Array.isArray(payload)) {
    return { data: payload, meta: { total: payload.length } }
  }
  return { data: [], meta: { total: 0 } }
}

// -- Organisation - Templates ---

export function listTemplates(holderType, holderId, params = {}) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/templates`, { params })
    .then((res) => {
      const d = res.data
      return Array.isArray(d.data) ? d.data : d.data ?? []
    })
}

export function getTemplate(holderType, holderId, templateId) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/templates/${templateId}`)
    .then(unwrap)
}

export function customizeTemplate(holderType, holderId, mailTypeId) {
  return getApiClient()
    .post(`${prefix}/${holderType}/${holderId}/templates/customize/${mailTypeId}`)
    .then(unwrap)
}

export function updateTemplate(holderType, holderId, templateId, data) {
  return getApiClient()
    .put(`${prefix}/${holderType}/${holderId}/templates/${templateId}`, data)
    .then(unwrap)
}

export function deleteTemplate(holderType, holderId, templateId) {
  return getApiClient().delete(`${prefix}/${holderType}/${holderId}/templates/${templateId}`)
}

export function previewTemplate(holderType, holderId, data) {
  return getApiClient()
    .post(`${prefix}/${holderType}/${holderId}/templates/preview`, data)
    .then(unwrap)
}

export function previewRaw(holderType, holderId, data) {
  return getApiClient()
    .post(`${prefix}/${holderType}/${holderId}/templates/preview-raw`, data)
    .then(unwrap)
}

export function sendTest(holderType, holderId, data) {
  return getApiClient()
    .post(`${prefix}/${holderType}/${holderId}/templates/send-test`, data)
    .then(unwrap)
}

// -- Organisation - Types ---

export function listTypes(holderType, holderId) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/types`)
    .then((res) => res.data?.data ?? [])
}

export function getType(holderType, holderId, typeId) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/types/${typeId}`)
    .then(unwrap)
}

// -- Organisation - Settings ---

export function getSettings(holderType, holderId) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/settings`)
    .then(unwrap)
}

export function updateSettings(holderType, holderId, data) {
  return getApiClient()
    .put(`${prefix}/${holderType}/${holderId}/settings`, data)
    .then(unwrap)
}

// -- Organisation - Logs ---

export function listLogs(holderType, holderId, params = {}) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/logs`, { params })
    .then(unwrapList)
}

// -- Admin - Layouts ---

export function listLayouts(holderType, holderId) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/admin/layouts`)
    .then((res) => {
      const d = res.data
      return Array.isArray(d.data) ? d.data : d.data ?? []
    })
}

export function getLayout(holderType, holderId, layoutId) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/admin/layouts/${layoutId}`)
    .then(unwrap)
}

export function updateLayout(holderType, holderId, layoutId, data) {
  return getApiClient()
    .put(`${prefix}/${holderType}/${holderId}/admin/layouts/${layoutId}`, data)
    .then(unwrap)
}

export function previewLayout(holderType, holderId, layoutId, data = {}) {
  return getApiClient()
    .post(`${prefix}/${holderType}/${holderId}/admin/layouts/${layoutId}/preview`, data)
    .then(unwrap)
}

// -- Admin - Types & defaults ---

export function adminListTypes(holderType, holderId, params = {}) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/admin/types`, { params })
    .then((res) => {
      const d = res.data
      return Array.isArray(d.data) ? d.data : d.data ?? []
    })
}

export function adminGetType(holderType, holderId, typeId) {
  return getApiClient()
    .get(`${prefix}/${holderType}/${holderId}/admin/types/${typeId}`)
    .then(unwrap)
}

export function adminUpdateType(holderType, holderId, typeId, data) {
  return getApiClient()
    .put(`${prefix}/${holderType}/${holderId}/admin/types/${typeId}`, data)
    .then(unwrap)
}

export function adminUpdateDefault(holderType, holderId, typeId, data) {
  return getApiClient()
    .put(`${prefix}/${holderType}/${holderId}/admin/types/${typeId}/default`, data)
    .then(unwrap)
}

export function adminSendTest(holderType, holderId, typeId, data) {
  return getApiClient()
    .post(`${prefix}/${holderType}/${holderId}/admin/types/${typeId}/send-test`, data)
    .then(unwrap)
}
